document.addEventListener('DOMContentLoaded', () => {
  // Initialize counters animation
  const countersSection = document.querySelector('.counters-grid');
  
  if (countersSection) {
    initCountersAnimation(countersSection);
  }
  
  // Handle Shopify editor
  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.counters-grid');
      if (section) initCountersAnimation(section);
    });
    
    // Reset animation when exiting editor mode
    document.addEventListener('shopify:section:deselect', () => {
      resetAllCounters();
    });
  }
});

function initCountersAnimation(section) {
  // Reset all counters to initial state
  resetAllCounters();
  
  // Check if counters are in viewport
  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.5
  };
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        animateCounters(entry.target);
      } else {
        // Reset counters when they leave viewport to allow re-animation
        resetCounters(entry.target);
      }
    });
  }, observerOptions);
  
  observer.observe(section);
}

function resetAllCounters() {
  const allCounters = document.querySelectorAll('.counter-number');
  allCounters.forEach(counter => {
    const originalValue = counter.dataset.originalValue;
    counter.textContent = originalValue;
    counter.classList.remove('animating');
  });
}

function resetCounters(section) {
  const counters = section.querySelectorAll('.counter-number');
  counters.forEach(counter => {
    const originalValue = counter.dataset.originalValue;
    counter.textContent = originalValue;
    counter.classList.remove('animating');
  });
}

function animateCounters(section) {
  const counterCards = section.querySelectorAll('.counter-card');
  
  // Updated durations: 0.5s, 1.3s, 1.6s, 1.9s
  const durations = [400, 400, 400, 400];
  
  counterCards.forEach((card, index) => {
    // Use modulo to handle cases with more than 4 counters
    const durationIndex = index % durations.length;
    const duration = durations[durationIndex];
    
    const counterElement = card.querySelector('.counter-number');
    const originalValue = counterElement.dataset.originalValue;
    const isNumeric = counterElement.dataset.isNumeric === 'true';
    
    // Reset counter before animating
    counterElement.textContent = '0';
    counterElement.classList.remove('animating');
    
    if (isNumeric) {
      // Extract numeric value (remove any non-numeric characters like +, k, etc.)
      const numericValue = parseInt(originalValue.replace(/\D/g, ''));
      
      // Start animation with ascending numbers
      animateCounterSmooth(counterElement, numericValue, duration, originalValue);
    } else {
      // For non-numeric values, just show the original value
      counterElement.textContent = originalValue;
    }
  });
}

function animateCounterSmooth(element, finalValue, duration, originalDisplayValue) {
  const startTime = Date.now();
  const isLargeNumber = finalValue > 1000;
  
  // Add animating class for visual effect
  element.classList.add('animating');
  
  function updateCounter() {
    const currentTime = Date.now();
    const elapsed = currentTime - startTime;
    const progress = Math.min(elapsed / duration, 1);
    
    if (progress < 1) {
      // Calculate current value based on linear progress (no easing delay)
      const currentValue = Math.floor(progress * finalValue);
      element.textContent = formatNumber(currentValue, isLargeNumber);
      requestAnimationFrame(updateCounter);
    } else {
      // Animation complete - show final value immediately
      element.textContent = originalDisplayValue;
      element.classList.remove('animating');
    }
  }
  
  // Start the animation immediately with initial value
  element.textContent = '0';
  requestAnimationFrame(updateCounter);
}

function formatNumber(num, isLarge) {
  if (isLarge) {
    // Format large numbers with commas
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return num.toString();
}